import { pl } from 'date-fns/locale';
import { Label } from '@ooh/ui/components/label';
import { DateRangeButtonField } from '@ooh/ui/components/date-range-button-field';

export interface GlobalManualDateRangeFieldsLabels {
  sectionLabel: string;
  dateRangePlaceholder?: string;
}

export interface GlobalManualDateRangeFieldsProps {
  dateFrom: string;
  dateTo: string;
  onChange: (next: { from: string; to: string }) => void;
  labels: GlobalManualDateRangeFieldsLabels;
  testIdPrefix?: string;
}

/**
 * One whole-file date range, required when the supplier file carries no
 * per-row date information at all — every listed unit gets this same window.
 */
export function GlobalManualDateRangeFields({
  dateFrom,
  dateTo,
  onChange,
  labels,
  testIdPrefix = 'global-manual-date-range',
}: GlobalManualDateRangeFieldsProps) {
  return (
    <div className="space-y-1.5">
      <Label required>{labels.sectionLabel}</Label>
      <DateRangeButtonField
        id={`${testIdPrefix}-trigger`}
        testId={testIdPrefix}
        fromValue={dateFrom}
        toValue={dateTo}
        onChange={onChange}
        placeholder={labels.dateRangePlaceholder}
        locale={pl}
      />
    </div>
  );
}
